export const supports = {
    geolocation: () => navigator && 'geolocation' in navigator,
};
